import {
  SET_RANKLIST,
  SET_TOTAL_DRAIN
} from './mutation_types'
import {
  getRanking,
  getTotalDrain
} from '../api'

const state = {
  rankList: [],
  totalDrain: []
}

const actions = {
  getRankList({ commit }) {
    getRanking().then(res => {
      commit(SET_RANKLIST, res.data.data_collect || [])
    })
  },
  getTotalDrain({ commit }) {
    getTotalDrain().then(res => {
      commit(SET_TOTAL_DRAIN, res.data.data_collect)
    })
  }
}

const mutations = {
  [SET_RANKLIST](state, data) {
    state.rankList = data
  },
  [SET_TOTAL_DRAIN](state, data) {
    state.totalDrain = data
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/globalStatis.js